import { useState, useEffect, useCallback } from 'react';
import { apiGet, apiPost } from '../shared/apiClient';

export interface SerialBridgeStatus {
  active: boolean;
  squadraConnected: boolean;
  squadraPort: number;
  squadraConnectedAt: string | null;
  squadraRemoteAddress: string | null;
  operatoreConnected: boolean;
  operatorePort: number;
  operatoreConnectedAt: string | null;
  operatoreRemoteAddress: string | null;
  graceActive?: boolean;
  graceSecondsLeft?: number;
  bytesTx: number;
  bytesRx: number;
  lastActivity: string | null;
}

export function useSerialBridge() {
  const [status, setStatus] = useState<SerialBridgeStatus | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [resetting, setResetting] = useState<boolean>(false);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await apiGet<{ ok: boolean; status: SerialBridgeStatus }>('/serial/status');
      if (res.data?.ok && res.data?.status) {
        setStatus(res.data.status);
        setError(null);
      }
    } catch (err: any) {
      setError(err?.response?.data?.errore || err?.message || 'Errore recupero stato');
    } finally {
      setLoading(false);
    }
  }, []);

  const resetBridge = useCallback(async () => {
    setResetting(true);
    try {
      const res = await apiPost<{ ok: boolean; status: SerialBridgeStatus }>('/serial/reset', {});
      if (res.data?.ok && res.data?.status) {
        setStatus(res.data.status);
      }
    } catch (err: any) {
      setError(err?.response?.data?.errore || err?.message || 'Errore reset');
    } finally {
      setResetting(false);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 2500);
    return () => clearInterval(interval);
  }, [fetchStatus]);

  return {
    status,
    loading,
    error,
    resetting,
    refresh: fetchStatus,
    resetBridge,
  };
}
